import { goTo } from './browserLocation';

export const setCookie = function (name, value, days) {
    // Only a finite number can produce a real date here. `days` omitted (or null, NaN,
    // Infinity, a string) made the arithmetic non-finite, toUTCString() returned the literal
    // "Invalid Date", and the cookie went out with an `expires=Invalid Date` attribute that
    // every browser throws away. Write no attribute at all instead of a malformed one.
    // No default is invented on purpose: all 21 live production call sites pass a numeric
    // literal (365, 7, 3), so the bytes they send are unchanged by this fix (CK-4).
    var expires = "";
    if (typeof days === 'number' && isFinite(days)) {
        var d = new Date();
        d.setTime(d.getTime() + (days*24*60*60*1000));
        // The type of `days` is not the whole story: `days*86400000` can leave Date's
        // ±8.64e15 ms window (the threshold is just under |days| = 1e8), setTime() then
        // stores NaN and toUTCString() is back to the literal "Invalid Date". Checking the
        // resulting instant rather than the magnitude keeps the boundary exact, and it is
        // the only representable-date test that also holds when the clock moves.
        if (!isNaN(d.getTime())) expires = "expires="+d.toUTCString()+"; ";
    }
    // Encoded, so a ";" in the value cannot end it and start an attribute of its own. SameSite=Lax
    // keeps the cookies off cross-site subrequests; Secure only on https, where it can be honoured.
    // The scheme is read off document.URL, the same address as window.location: specs can stand an
    // https one in for it, which jsdom's unforgeable window.location does not allow.
    var secure = /^https:/.test(document.URL) ? "; Secure" : "";
    document.cookie = name + "=" + encodeURIComponent(value || "") + "; " + expires + "path=/; SameSite=Lax" + secure;
  }
  export const getCookie = function (name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) {
        var raw = c.substring(nameEQ.length, c.length);
        try {
          return decodeURIComponent(raw);
        } catch {
          // A URIError: a value written before setCookie encoded can hold a "%" that is not a valid
          // escape. Year-long cookies like that are still in members' browsers, so it is returned as
          // stored; a valid unencoded value ({"a":1}, a host name) decodes to itself anyway.
          return raw;
        }
      }
    }
    return null;
  }
  export const deleteAllCookies =function () {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
        // Trim: `document.cookie` joins entries with "; ", so every cookie after the first
        // keeps a leading space. RFC 6265 forbids whitespace in the name, and a browser will
        // not match " b" against "b" — so without trimming, only the first cookie is expired.
        var cookie = cookies[i].trim();
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    }
    goTo('/');
}

export const delete_cookie =function (name) {
  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
}
export const expireAllCookies =function(name,paths) {
  console.log("expire Cookie : ", name)
  var expires = new Date(0).toUTCString();

  // expire null-path cookies as well
  document.cookie = name + '=; expires=' + expires;

  // A string has a .length too, so the old loop happily walked '/en' character by character:
  // the intended path was never expired and every character became its own bogus path. Only
  // a real array is a path list; anything else is a caller mistake and fails loudly, exactly
  // as a missing argument already did (CK-5).
  if (!Array.isArray(paths)) {
      var kind = paths === null ? 'null' : typeof paths;
      // The character-by-character note only makes sense for a string, which is the case that
      // used to walk silently. Appending it unconditionally would put it in the message for a
      // missing argument too, where it explains nothing.
      throw new TypeError(
          'expireAllCookies: paths must be an array, got ' + kind +
          (kind === 'string'
              ? ' — a bare string has a length as well and would be walked character by character'
              : '')
      );
  }

  for (var i = 0, l = paths.length; i < l; i++) {
      // The callers (utils/session.js, which every logout goes through, and Login) end the
      // list with localStorage.getItem('end-page-url'), which is null whenever that key was never
      // written; `path=null` expires nothing. Skip only null/undefined — '' is a value the
      // caller supplied, not a missing one.
      if (paths[i] === null || paths[i] === undefined) continue;
      // The entry goes straight into document.cookie, so a `;` inside it CLOSES the path
      // attribute and opens another one: a stored "/; Secure" turned this write into
      // `name=; path=/; Secure; expires=<epoch>`, and a Secure expiry does not delete a cookie
      // that was set without Secure — logout stopped logging out (W3A-T7-1). Control characters
      // are refused for the same reason (CR/LF split the header in any consumer that forwards
      // it). Skipped and reported, NOT thrown: throwing would abandon the remaining paths and
      // break logout outright, which is worse than leaving one path unexpired.
      if (/[;,\u0000-\u001f\u007f]/.test(String(paths[i]))) {
          console.log('expireAllCookies: refusing a path with a cookie-attribute separator', paths[i]);
          continue;
      }
      document.cookie = name + '=; path=' + paths[i] + '; expires=' + expires;
  }
}
